import React, { useState, useEffect } from "react";
import { Megaphone, ExternalLink } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CampaignTracker = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/admin/config/campaigns`);
        setData(res.data);
      } catch { /* */ }
      setLoading(false);
    })();
  }, []);

  if (loading) {
    return (
      <div className="bg-card rounded-lg border p-6">
        <h2 className="text-lg font-bold mb-4 flex items-center gap-2"><Megaphone className="w-5 h-5 text-primary" /> Campagnes</h2>
        <div className="flex justify-center py-8"><div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" /></div>
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="bg-card rounded-lg border p-6" data-testid="campaign-tracker">
      <h2 className="text-lg font-bold mb-5 flex items-center gap-2">
        <Megaphone className="w-5 h-5 text-primary" /> Performances Campagnes
      </h2>

      {/* Diagnostic campaigns */}
      {data.campaigns.length > 0 && (
        <div className="mb-6">
          <p className="text-sm font-semibold mb-3">Diagnostics par campagne (UTM)</p>
          <div className="overflow-x-auto">
            <table className="w-full text-xs">
              <thead>
                <tr className="border-b text-left text-muted-foreground">
                  <th className="pb-2 pr-3">Source</th>
                  <th className="pb-2 pr-3">Campagne</th>
                  <th className="pb-2 pr-3 text-center">Diagnostics</th>
                  <th className="pb-2 pr-3 text-center">Contactés</th>
                  <th className="pb-2 pr-3 text-center">Taux</th>
                  <th className="pb-2 text-center">Score moy.</th>
                </tr>
              </thead>
              <tbody>
                {data.campaigns.map((c, i) => (
                  <tr key={i} className="border-b border-muted/50">
                    <td className="py-2 pr-3 font-medium">{c.source}</td>
                    <td className="py-2 pr-3 text-muted-foreground">{c.campaign}</td>
                    <td className="py-2 pr-3 text-center font-bold">{c.diagnostics}</td>
                    <td className="py-2 pr-3 text-center">{c.contacted}</td>
                    <td className="py-2 pr-3 text-center">
                      <span className={`px-1.5 py-0.5 rounded font-medium ${
                        c.diagnostics > 0 && (c.contacted / c.diagnostics) >= 0.5
                          ? "bg-green-100 text-green-700"
                          : "bg-orange-100 text-orange-700"
                      }`}>
                        {c.diagnostics > 0 ? Math.round((c.contacted / c.diagnostics) * 100) : 0}%
                      </span>
                    </td>
                    <td className="py-2 text-center">{c.avg_score}/100</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Lead sources */}
      {data.lead_sources.length > 0 && (
        <div>
          <p className="text-sm font-semibold mb-3">Leads par source</p>
          <div className="space-y-1.5">
            {data.lead_sources.map((s, i) => (
              <div key={i} className="flex items-center justify-between text-xs bg-muted/30 rounded px-3 py-2">
                <span className="text-muted-foreground truncate mr-3">{s.source}</span>
                <div className="flex items-center gap-3 whitespace-nowrap">
                  <span className="font-bold">{s.leads} leads</span>
                  <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${
                    s.sent_crm === s.leads ? "bg-green-100 text-green-700" : "bg-yellow-100 text-yellow-700"
                  }`}>
                    {s.sent_crm} CRM
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {data.campaigns.length === 0 && data.lead_sources.length === 0 && (
        <div className="text-center py-8 text-sm text-muted-foreground">
          <p>Aucune donnée de campagne.</p>
          <p className="mt-2">Ajoutez des UTM à vos liens : <code className="bg-muted px-1.5 py-0.5 rounded text-xs">?utm_source=meta&utm_campaign=plombier_vaud</code></p>
        </div>
      )}
    </div>
  );
};
